<template>
  <div>
    <div
      class="font-weight-medium text-uppercase mr-5 mt-2 cursor-pointer"
      @click="toggleFilterDrawer()"
    >
      <span>
        <v-badge color="#F3425C" inline left v-if="filterCounter > 0">
          <template v-slot:badge>
            <span class="font-weight-bold">{{ filterCounter }}</span>
          </template>
        </v-badge>
      </span>
      Filters
    </div>
    <v-navigation-drawer
      v-model="filterDrawer"
      class="px-6 pt-6 overflow-y-hidden pr-2"
      id="filter-contact-drawer"
      width="550px"
      right
      fixed
      temporary
    >
      <div class="mb-5 fixed-drawer pr-8 pl-2">
        <v-row no-gutters>
          <v-col align="left">
            <h5 class="text-h5 font-weight-600 float-left text-capitalize">
              <span class="secondary--font"> Filters </span>
            </h5>
          </v-col>
          <v-col align="right">
            <v-btn icon @click.stop="filterDrawer = false" class="float-right"
            v-track="'close-filter-drawer'">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12 py-2">
            <span class="body-1"> Filter contacts based on below fields. </span>
          </v-col>
        </v-row>
        <v-card elevation="0">
          <v-form class="mt-1">
            <v-card-text class="px-0">
              <v-autocomplete
                v-model="selectedCompany"
                :items="associatedField.companyList"
                label="Company"
                class="customize-select"
                outlined
                clearable
                deletable-chips
                small-chips
                multiple
                attach
                required
                @change="enableApply()"
              >
              </v-autocomplete>
            </v-card-text>
          </v-form>
        </v-card>
      </div>
      <template v-slot:append>
        <div class="pa-2">
          <v-card-actions class="px-0 d-flex align-end">
            <v-btn
              class="font-weight-bold mb-4"
              v-track="'clear-selected-filter'"
              @click.stop="clearSelectedFilter()"
              outlined
            >
            Clear Filter
            </v-btn>
            <v-btn
              id="apply-filter"
              :dark="actionButton"
              :disabled="!actionButton"
              class="font-weight-bold mb-4"
              v-track="'apply-filter'"
              @click="applyFilter()"
            >
            Apply
            </v-btn>
          </v-card-actions>
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>
<script>
import { contactMixin } from "@/mixins/contact";
export default {
  name: "filter-drawer",
  mixins: [contactMixin],
  data() {
    return {
      filterDrawer: false,
      filterCounter: 0,
      selectedCompany: [],
      actionButton: false,
      companyList: [],
      menu: false,
    };
  },
  computed: {
    associatedField() {
      return this.$store.getters["contacts/associatedField"];
    },
  },
  mounted() {
    this.getFilteredData();
    this.checkFilterCount();
  },
  methods: {
    enableApply() {
      this.actionButton = true;
    },
    /** Method to open drawer */
    toggleFilterDrawer() {
      this.filterDrawer = true;
      this.actionButton = false;
      this.getFilteredData();
    },
    /** method to get all the filtered data saved in store */
    getFilteredData() {
      let filterData = this.$store.getters["contacts/filterData"];
      this.selectedCompany = filterData.selectedCompany;
    },
    /** Method to set data in store */
    setDataInStore() {
      let filterData = {
        selectedCompany: this.selectedCompany,
      };
      this.$store.dispatch("contacts/filterData", [filterData]);
    },
    /** Method to apply filter on clicking of apply button */
    async applyFilter() {
      let groupFilter = []
      let selectedCompanyVal = {}
      if (this.selectedCompany && this.selectedCompany.length > 0) {
        if (this.selectedCompany.includes('--')) {
          selectedCompanyVal['company_blank'] = true
          selectedCompanyVal['m']='or'
        }
        selectedCompanyVal['company_matches_any'] = this.selectedCompany.filter(item => item !== '--');
      }
      groupFilter.push(selectedCompanyVal)
      let data = {
        ['g']: groupFilter
      };
      this.$store.dispatch("contacts/appliedFilter", [data]);
      this.setDataInStore();
      await this.$emit("applyFilter");
      this.checkFilterCount();
      this.filterDrawer = false;
    },
    /** method to count the applied filter */
    checkFilterCount() {
      let appliedFilter = this.$store.getters["contacts/appliedFilter"];
      this.filterCounter = 0;
      for (var key in appliedFilter) {
        if (appliedFilter[key] && appliedFilter[key].length !== 0) {
          this.filterCounter = this.filterCounter + 1;
        }
      }
    },
    /** Method to clear selected filter on clicking of clear filter button */
    async clearSelectedFilter() {
      this.reSetFilter();
      await this.$emit("applyFilter");
      this.filterDrawer = false;
    },
    /** Method to reset the applied filter */
    reSetFilter() {
      this.selectedCompany = [];
      this.$store.dispatch("contacts/appliedFilter", [{}]);
      this.checkFilterCount();
      this.setDataInStore();
      this.getFilteredData();
    },
  },
};
</script>
<style lang="scss">
#filter-contact-drawer {
  .v-navigation-drawer__content {
    padding-bottom: 100px !important;
  }
}
</style>
